<div class="field" [formGroup]="control">
  <small class="error" *ngIf="input?.errors?.['required']">
    Preenchimento obrigatório
  </small>
  <small class="error" *ngIf="input?.errors?.['email']">
    E-mail inválido
  </small>
  <small class="error" *ngIf="input?.errors?.['invalidCpfCnpj']">
    {{ invalidMessage || "CPF/CNPJ inválido" }}
  </small>
  <small class="error" *ngIf="input?.errors?.['invalidDate']">
    Data não pode ser inferior à atual
  </small>
  <small class="error" *ngIf="input?.errors?.['maxlength']">
    Máximo de {{ input?.errors?.["maxlength"]?.requiredLength }} caracteres
    permitidos
  </small>
  <small class="error" *ngIf="showMaxLengthWarning">
    Limite de {{ maxlength }} caracteres atingido
  </small>
  <small class="hint" *ngIf="hint">
    {{ hint }}
  </small>

  <small class="error" *ngIf="input?.errors?.['customInvalid']">
    {{ invalidMessage || "Valor inválido" }}
  </small>
  <ng-container *ngIf="!input?.invalid">
    <ng-content></ng-content>
  </ng-container>
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'textarea'">
      <textarea
        [id]="id"
        [mask]="mask"
        [formControlName]="formControlName"
        [placeholder]="placeholder"
        [value]="value"
        [dropSpecialCharacters]="true"
        [maxlength]="maxlength"
        (input)="onInput($event)"
      ></textarea>
    </ng-container>
    <ng-container *ngSwitchCase="'currency'">
      <!-- Máscara de reais (R$ 1.234,56, dígitos entram pela direita).
           Entrega number ao FormControl; sem ngx-mask para não haver dois
           ControlValueAccessor no mesmo input. -->
      <input
        appCurrencyMask
        type="text"
        [id]="id"
        [formControlName]="formControlName"
        [placeholder]="placeholder || 'R$ 0,00'"
        (input)="onInput($event)"
      />
    </ng-container>
    <ng-container *ngSwitchDefault>
      <input
        [validation]="validation"
        [id]="id"
        [type]="type"
        [mask]="mask"
        [prefix]="prefix"
        [thousandSeparator]="thousandSeparator"
        [decimalMarker]="decimalMarker"
        [formControlName]="formControlName"
        [placeholder]="placeholder"
        [value]="value"
        [attr.autocomplete]="autocomplete || null"
        [dropSpecialCharacters]="dropSpecialCharacters"
        [suffix]="mask === 'percent.2' ? '%' : ''"
        [maxlength]="maxlength"
        (input)="onInput($event)"
      />
    </ng-container>
  </ng-container>
  <label [for]="id">
    {{ label }}
  </label>
</div>
